export default __webpack_public_path__ + "static/media/dropdown.9592cbf8.svg";